var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('breadcrumbs',{staticClass:"mb-3"}),_vm._v(" "),_c('v-btn',{staticClass:"primary mb-4",attrs:{"depressed":"","nuxt":"","to":{name: 'member', params: {id: 0}}}},[_vm._v("\n        "+_vm._s(_vm.$t('new_member_profile'))+"\n    ")]),_vm._v(" "),_c('clients-table',{attrs:{"is-member":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }